import type React from "react";

interface CallIconProps {
  className?: string;
  style?: React.CSSProperties;
}

export const CallIcon: React.FC<CallIconProps> = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <g transform="translate(2.25, 3)">
      {/* 5개의 수직 바로 구성된 call/voice 아이콘 */}
      <rect x="0" y="3.75" width="1.5" height="4.5" rx="0.75" fill="currentColor" />
      <rect x="3" y="6" width="1.5" height="3" rx="0.75" fill="currentColor" />
      <rect x="6" y="0" width="1.5" height="12" rx="0.75" fill="currentColor" />
      <rect x="9" y="3" width="1.5" height="6" rx="0.75" fill="currentColor" />
      <rect x="12" y="1.5" width="1.5" height="9" rx="0.75" fill="currentColor" />
    </g>
  </svg>
);
